<template>
  <transition name="fade" mode="out-in">
    <div
      v-if="overlayActive"
      class="fixed inset-0 md:px-112 sm:px-56 px-24 bg-black-full bg-opacity-25 z-sidebar-overlay flex items-center"
      @click.self="closeModal"
    >
      <transition name="slide" mode="out-in">
        <div v-if="showContent" class="bg-main mx-auto flex max-w-680 w-full relative">
          <div
            v-if="isCancellable"
            class="absolute top-16 right-16 w-32 h-32 cursor-pointer select-none flex justify-center items-center z-10"
            @click="closeModal"
          >
            <fa
              class="text-lg cursor-pointer select-none"
              :icon="['fal', 'times']"
            />
          </div>
          <div

            class="flex-grow"
            :class="{
              [maxHeightString]: maxHeight,
              'overflow-y-auto': maxHeight,
            }"
          >
            <slot />
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script setup lang="ts">
interface Props {
  maxHeight?: number;
  button?: boolean;
  isCancellable?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  maxHeight: ()=> 0,
  isCancellable: true,
});
const maxHeightString = computed(()=>{
  return props.maxHeight > 0 ? `max-h-${props.maxHeight}` : '';
});

const overlayActive = ref(false);
const showContent = ref(false);

onMounted(()=> {
  setTimeout(() => (overlayActive.value = true), 50);
  setTimeout(() => (showContent.value = true), 100);
  document.body.classList.add('locked');
});
onBeforeUnmount(()=> {
  document.body.classList.remove('locked');
});
const emit = defineEmits(['close-modal']);
const closeModal = () => {
  if (props.isCancellable) {
    emit('close-modal');
  }
};

</script>
